import { ROLE_TYPE } from '@/api/type/commonTypes';
import { fonts } from '@/theme/fonts';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface MemberInfoSectionProps {
  role: ROLE_TYPE;
}
const MemberInfoSection = ({ role }: MemberInfoSectionProps) => {
  const { t } = useTranslation();
  const type = role === 'PLAYER' ? 'PLAYER' : 'CENTER';
  return (
    <>
      <HeaderSection>
        <Title>
          {t('signUp.title')} ({type})
        </Title>
        <Subtitle>
          {t('signUp.description', {
            type: type,
          })}
        </Subtitle>
        <WarningText>{t('signUp.notice')}</WarningText>
      </HeaderSection>

      <Section>
        <SectionTitle>{t('signUp.accountActivation')}</SectionTitle>
        <GridContainer>
          <FormGroup>
            <Label>{t('signUp.permission')}</Label>
            <Input
              type="text"
              value={`${type} (${t('signUp.submit')})`}
              disabled
            />
          </FormGroup>
        </GridContainer>
      </Section>
    </>
  );
};

export default MemberInfoSection;

const HeaderSection = styled.div`
  margin-bottom: 24px;
`;

const Title = styled.h2`
  margin: 0 0 8px;
  font-family: ${fonts.family.inter};
  font-size: 20px;
  font-weight: ${fonts.weight.semiBold};
  color: #111827;
`;

const Subtitle = styled.p`
  margin: 0 0 16px;
  font-size: 14px;
  color: #6b7280;
`;

const WarningText = styled.div`
  padding: 12px 16px;
  border-radius: 6px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #c2410c;
  font-size: 13px;
  line-height: 1.5;
`;

const Section = styled.section`
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
`;

const SectionTitle = styled.h3`
  margin-bottom: 0 0 16px;
  font-size: 15px;
  font-weight: ${fonts.weight.semiBold};
  color: #374151;
`;

const GridContainer = styled.div`
  color: #374151;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: ${fonts.weight.semiBold};
  color: #6b7280;
`;

const Input = styled.input`
  height: 40px;
  padding: 0 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #f9fafb;
  color: #9ca3af;
  font-size: 14px;
`;
